export type Language = 'zh-CN' | 'en-US';
export type LanguagePreference = 'system' | Language;
export type TranslationParams = Record<string, string | number>;

export const LANGUAGE_STORAGE_KEY = 'ossshelf.language';

export function isLanguagePreference(value: unknown): value is LanguagePreference {
  return value === 'system' || value === 'zh-CN' || value === 'en-US';
}

export function resolveLanguage(preference: LanguagePreference, languages: readonly string[]): Language {
  if (preference !== 'system') return preference;
  for (const locale of languages) {
    if (/^zh(?:[-_]|$)/i.test(locale)) return 'zh-CN';
    if (/^en(?:[-_]|$)/i.test(locale)) return 'en-US';
  }
  return 'en-US';
}

export function interpolate(text: string, params?: TranslationParams): string {
  return text.replace(/\{\{(\w+)\}\}/g, (placeholder, key: string) =>
    params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : placeholder,
  );
}

export function translateMessage(
  language: Language,
  dictionary: Record<string, string>,
  message: string,
  params?: TranslationParams,
): string {
  const translated = language === 'en-US' && Object.prototype.hasOwnProperty.call(dictionary, message)
    ? dictionary[message]!
    : message;
  return interpolate(translated, params);
}
